import { Builder } from '@builder.io/react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedCurrency } from '../../../../../../store/user';
import { useKeenSlider } from 'keen-slider/react';
import { LiaAngleLeftSolid, LiaAngleRightSolid } from 'react-icons/lia';
import AppealGivingProductBox from '../../../../../../pages/MATWAppeal/components/appealGivingProductBox';
import { BASKET_CACHE_KEY, HandleLocalStorage } from '../../../../../../utils/handleLocalStorage';
import useHandleAddProduct from '../../../../../../utils/handleAddProduct';
import { useMediaQuery } from 'react-responsive';
import AppealDetailsResultSection from './appealDetailsResultSection';
import { selectProducts, selectLastOrders } from '../../../../../../store/products';

const AppealLevelGiving = props => {
  /* ----------------------------- Start variables ---------------------------- */
  const { lang = 'en', title, appealsProducts = [] } = props;
  let basketStatesFromLocalStorage = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY));
  const [addProduct, editProduct, removeProduct] = useHandleAddProduct();
  const [loaded, setLoaded] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const allOrders = useSelector(state => selectLastOrders(state));
  const _allProducts = useSelector(state => selectProducts(state));
  const [selectedGivingProducts, setSelectedGivingProducts] = useState({
    products: [],
    total: 0,
  });
  const [allGivingProducts, setAllGivingProducts] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [products, setProducts] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [isMinimized, setIsMinimized] = useState(false);
  const [showMoreItems, setShowMoreItems] = useState(false);
  const MutationPlugin = slider => {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        slider.update();
      });
    });
    const config = { childList: true };

    slider.on('created', () => {
      observer.observe(slider.container, config);
    });
    slider.on('destroyed', () => {
      observer.disconnect();
    });
  };
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      mode: 'snap',
      loop: false,
      slideChanged(slider) {
        const { rel, maxIdx } = slider.track.details;
        setIsEnd(rel === maxIdx);
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
      breakpoints: {
        '(min-width: 320px)': {
          slides: { perView: 1.3, spacing: 20 },
        },
        '(min-width: 768px)': {
          slides: { perView: 2, spacing: 10 },
        },
        '(min-width: 1024px)': {
          slides: { perView: 3, spacing: 10 },
        },
        '(min-width: 1280px)': {
          slides: { perView: 4, spacing: 10 },
        },
      },
      slides: {
        origin: 'center',
      },
      // eslint-disable-next-line no-use-before-define
    },
    [MutationPlugin],
  );
  // Check if it’s desktop
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });
  // Decide when to show carousel vs. normal layout
  // For example:
  // - On desktop, if products.length > 3, show normal layout
  // - Otherwise, show carousel
  const showCarousel = isDesktop
    ? allGivingProducts.length > 3 // Desktop: only carousel if > 3 items
    : allGivingProducts.length > 1; // Mobile: carousel if more than 1 item
  const cloneWithQuantity = (product, quantity) => ({ ...product, quantity });
  /* -------------------------------------------------------------------------- */

  /* ------------------------------ Start Methods ----------------------------- */
  const updateBasket = (action, payload) => {
    action(payload);
    // Notify listeners
    window.dispatchEvent(new CustomEvent('basketUpdated', { detail: { key: BASKET_CACHE_KEY } }));
    handleSelectedGiving();
  };
  const handleAddQty = prd => {
    updateBasket(addProduct, { product: cloneWithQuantity(prd, 1), currency: selectedCurrencyStore, justAddToLocalStorage: true });
  };

  const handleReduceQty = prd => {
    if (prd.quantity > 1) {
      updateBasket(editProduct, { product: cloneWithQuantity(prd, -1), currency: selectedCurrencyStore, justAddToLocalStorage: true });
    } else {
      handleRemoveProduct(prd);
    }
  };

  const handleAddToGiving = (prd, quantity = 1) => {
    updateBasket(addProduct, { product: cloneWithQuantity(prd, quantity), currency: selectedCurrencyStore, justAddToLocalStorage: true });
  };

  const handleRemoveProduct = prd => {
    updateBasket(removeProduct, prd);
  };

  const handleSelectedGiving = () => {
    const basket = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY)) || {};
    const basketProducts = basket.products || [];
    let totalGiving = 0;
    const updatedProducts = allGivingProducts.map(product => {
      const match = basketProducts.find(b => b.product?.creator === product.creator);
      if (!match) return product; // No match, return as-is
      const quantity = match.quantity || 1;
      totalGiving += quantity * product[selectedCurrencyStore.toLowerCase()];
      return { ...product, isAdded: true, quantity };
    });
    const selectedProducts = updatedProducts.filter(p => p.isAdded);
    if (selectedProducts.length === 1) {
      setIsMinimized(false);
    }
    setProducts(updatedProducts);
    setSelectedGivingProducts(prev => ({
      ...prev,
      products: selectedProducts,
      total: totalGiving,
    }));
    console.log('when dispactch===');
  };
  const handleCurrency = (currency, basket) => {
    const updatedProducts = (basket.products || []).map(item => ({
      ...item,
      currency,
      product: { ...item.product, currency },
      total: item.quantity * item.product[currency],
      amount: item.product[currency],
    }));

    HandleLocalStorage({
      ...basket,
      currency,
      products: updatedProducts,
    });
  };

  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    let basketStatesFromLocalStorage = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY));
    if (basketStatesFromLocalStorage && basketStatesFromLocalStorage.currency !== selectedCurrencyStore) {
      handleCurrency(selectedCurrencyStore, basketStatesFromLocalStorage);
    }
    if (allGivingProducts[0]) {
      handleSelectedGiving();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allGivingProducts]);
  useEffect(() => {
    if (!_allProducts || !Object.keys(_allProducts).length) return;
    if (!allOrders) return;
    // Extract just the creator IDs from appealsProducts
    const appealsCreators = appealsProducts.map(ap => ap.creator);
    // Extract products that match appealsProducts creators
    const givingProducts = _allProducts.flatMap(item =>
      item.sub_categories.flatMap(sub => sub.products.filter(prod => appealsCreators.includes(prod.creator))),
    );
    // Normalize orders array
    const ordersArray = Array.isArray(allOrders) ? allOrders : allOrders?.data || [];
    // Add supporters count if orders exist
    const productsWithCounts = ordersArray.length
      ? (() => {
          const supportersMap = ordersArray.reduce((acc, order) => {
            if (appealsCreators.includes(order.creator)) {
              acc[order.creator] = (acc[order.creator] || 0) + (order.total_supporters || 0);
            }
            return acc;
          }, {});
          return givingProducts.map(product => ({
            ...product,
            total_count: supportersMap[product.creator] || 0,
          }));
        })()
      : givingProducts;
    setAllGivingProducts(productsWithCounts);
  }, [allOrders, _allProducts, appealsProducts]);
  /* -------------------------------------------------------------------------- */
  return (
    <>
      <div className="flex flex-col w-full justify-center mb-0 md:mb-6">
        <h2 className={`text-center text-DarkerBlue text-lg md:text-3xl w-full font-bold mb-2`}>{title}</h2>
      </div>
      <div className="md:px-4 max-w-full relative">
        <div className="md:w-[95%] mx-auto 2xl:w-full flex-wrap justify-center items-center relative">
          {products && products.length > 3 && (
            <div className="hidden md:flex">
              {instanceRef.current && (
                <div
                  className={`absolute flex justify-center items-center translate-y-1/2 w-8 h-8 top-[40%] -left-[18px] md:-left-[36px] z-10 rounded-full ${
                    currentSlide === 0 ? 'cursor-not-allowed bg-[#e6e6e6] text-[#9e9e9e]' : 'cursor-pointer bg-LightBlue bg-opacity-10 text-LightBlue'
                  }`}
                  onClick={e => e.stopPropagation() || instanceRef.current?.prev()}
                >
                  <LiaAngleLeftSolid size={25} />
                </div>
              )}
              {instanceRef.current && (
                <div
                  className={`absolute flex justify-center items-center translate-y-1/2 w-8 h-8 top-[40%] -right-[18px] md:-right-[36px] z-10 rounded-full ${
                    isEnd ? 'cursor-not-allowed bg-[#e6e6e6] text-[#9e9e9e]' : 'cursor-pointer bg-LightBlue bg-opacity-10 text-LightBlue'
                  }`}
                  onClick={e => e.stopPropagation() || instanceRef.current?.next()}
                >
                  <LiaAngleRightSolid size={25} />
                </div>
              )}
            </div>
          )}
          <>
            {showCarousel ? (
              <div ref={sliderRef} className={`keen-slider`}>
                {products &&
                  products.map((item, index) => {
                    return (
                      <div key={`active_carousel_${index}`} className={`keen-slider__slide basis-full flex justify-center py-4`}>
                        <div className="w-full max-w-[355px]">
                          <AppealGivingProductBox
                            product={item}
                            lang={lang}
                            currency={selectedCurrencyStore}
                            onAddQty={() => handleAddQty(item, index)}
                            onReduceQty={() => handleReduceQty(item, index)}
                            onAddToGiving={quantity => handleAddToGiving(item, quantity)}
                            basket={basketStatesFromLocalStorage}
                            isAdded={item.isAdded || false}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
            ) : (
              <div className={`flex justify-center gap-3`}>
                {products &&
                  products.map((item, index) => {
                    return (
                      <div key={`active_carousel_${index}`} className={`basis-1/4 flex justify-center py-4`}>
                        <div className="w-full max-w-[355px]">
                          <AppealGivingProductBox
                            product={item}
                            lang={lang}
                            currency={selectedCurrencyStore}
                            onAddQty={() => handleAddQty(item, index)}
                            onReduceQty={() => handleReduceQty(item, index)}
                            onAddToGiving={quantity => handleAddToGiving(item, quantity)}
                            basket={basketStatesFromLocalStorage}
                            isAdded={item.isAdded || false}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}
            {products && products.length > 1 && (
              <div className="flex md:hidden bg-white py-3 px-2 rounded-md justify-center items-center mx-auto mt-2 max-w-[300px]">
                {loaded && instanceRef.current && instanceRef.current.track.details && (
                  <div className="flex justify-center items-center relative w-full">
                    {[...Array(instanceRef.current.track.details.slides.length).keys()].map(idx => {
                      return (
                        <button
                          key={`q${idx}`}
                          onClick={() => {
                            instanceRef.current?.moveToIdx(idx);
                          }}
                          className={
                            'md:w-4 md:mx-2 mx-1 md:h-4 h-3  w-3 rounded-full ' +
                            (currentSlide === idx ? ' bg-LightBlue hover:opacity-60' : 'bg-[#C3C3C3]')
                          }
                        ></button>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </>
        </div>
      </div>
      {selectedGivingProducts.products.length ? (
        <AppealDetailsResultSection
          selectedGivingProducts={selectedGivingProducts}
          isMinimized={isMinimized}
          showMoreItems={showMoreItems}
          handleRemoveProduct={handleRemoveProduct}
          setShowMoreItems={setShowMoreItems}
          handleMinimize={() => setIsMinimized(!isMinimized)}
          lang={lang}
        />
      ) : (
        ''
      )}
    </>
  );
};

Builder.registerComponent(AppealLevelGiving, {
  name: 'AppealLevelGiving',
  inputs: [
    {
      name: 'title',
      label: 'Title',
      type: 'string',
      required: false,
      defaultValue: 'More ways to help',
    },
    {
      name: 'appealsProducts',
      type: 'array',
      subFields: [
        {
          name: 'creator',
          type: 'string',
        },
      ],
    },
  ],
});

export default AppealLevelGiving;
